// ============================================================
// PricingPlans.js — UPDATED (4 Plans + Yearly Toggle)
// Plans:
//   1. Flow Only (Self-Managed Setup) — ₹2,999/mo
//   2. Flow Only (Full Setup by Us)   — ₹3,999/mo
//   3. AI + Flow (Self-Managed)       — ₹4,999/mo
//   4. AI + Flow with Credits (Full Turnkey) — ₹6,999/mo [POPULAR]
// Yearly: 15% off on all plans
// ============================================================

import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Login from './Login';
import '../styles/pricing.css';

const PLANS = [
    {
        id: '1',
        name: 'Flow Only',
        subtitle: 'Self-Managed Setup',
        monthlyPrice: 2999,
        billingLabel: 'month',
        headerClass: 'pricing-plan-header-purple',
        features: [
            'Visual Flow Builder',
            'Unlimited Flows',
            'WhatsApp Integration',
            'Basic Analytics',
            '1,000 Messages/month',
        ],
        maxMessages: 1000,
        aiEnabled: false,
        popular: false,
        bestValue: false,
    },
    {
        id: '2',
        name: 'Flow Only',
        subtitle: 'Full Setup by Us',
        monthlyPrice: 3999,
        billingLabel: 'month',
        headerClass: 'pricing-plan-header-teal',
        features: [
            'Everything in Flow Only',
            'WhatsApp Business Account Setup',
            'Meta Developer Account Setup',
            'Complete Flow Configuration',
            '1,000 Messages/month',
            'Onboarding Support',
        ],
        maxMessages: 1000,
        aiEnabled: false,
        popular: false,
        bestValue: false,
    },
    {
        id: '4',
        name: 'AI + Flow with Credits',
        subtitle: 'Full Turnkey',
        monthlyPrice: 6999,
        billingLabel: 'month',
        headerClass: 'pricing-plan-header-blue',
        features: [
            'Everything in AI + Flow',
            'ChatTech24 AI Credits Included',
            'No OpenAI API Key Required',
            'GPT-4 Access',
            'Full WhatsApp + Meta Setup by Us',
            '10,000 Messages/month',
            'Priority Support',
        ],
        maxMessages: 10000,
        aiEnabled: true,
        popular: true,
        bestValue: true,
    },
];

function PricingPlans() {
    const navigate = useNavigate();
    const [isYearly, setIsYearly] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [upsellModal, setUpsellModal] = useState(null); // selected plan store karega
    const isAuthenticated = !!localStorage.getItem('token');
    

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const getPrice = (monthlyPrice) => {
        if (isYearly) {
            return Math.round(monthlyPrice * 12 * 0.85); // annual total
        }
        return monthlyPrice;
    };

    const handleSelectPlan = (plan) => {
    if (!isAuthenticated) {
        navigate('/', { state: { openLogin: true } });
        return;
    }
    // Monthly me click kiya to upsell modal dikhao
    if (!isYearly) {
        setUpsellModal(plan);
        return;
    }
    // Yearly already selected hai to seedha checkout
    navigate('/checkout', { state: { plan: { ...plan, price: getPrice(plan.monthlyPrice), billing_cycle: 'yearly' } } });
};
const handleContinueMonthly = () => {
    const plan = upsellModal;
    setUpsellModal(null);
    navigate('/checkout', { state: { plan: { ...plan, price: plan.monthlyPrice, billing_cycle: 'monthly' } } });
};

const handleUpgradeYearly = () => {
    const plan = upsellModal;
    setUpsellModal(null);
    navigate('/checkout', { state: { plan: { ...plan, price: Math.round(plan.monthlyPrice * 12 * 0.85), billing_cycle: 'yearly' } } });
};

    const faqs = [
        { q: 'Can I change my plan later?', a: 'Yes, you can upgrade or downgrade your plan at any time from your dashboard.' },
        { q: 'What payment methods are accepted?', a: 'We accept all major credit/debit cards, UPI, and net banking via Razorpay.' },
        { q: 'Is there a free trial?', a: 'Contact our team for a personalised demo and trial period.' },
        { q: 'What happens if I exceed the message limit?', a: 'We will notify you and you can upgrade your plan to continue without interruption.' },
    ];

    return (
        <div className="pricing-wrapper">

            {/* ── NAVBAR ── */}
            <nav className={`ct-nav ${scrolled ? 'ct-nav-scrolled' : ''}`}>
                <div className="ct-nav-brand" onClick={() => navigate('/')}>
                    <img src="/logo.png" alt="ChatTech24" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                </div>
                <div className="ct-nav-links">
                    <Link to="/how-it-works" className="ct-nav-link">How It Works</Link>
                    <Link to="/features" className="ct-nav-link">Features</Link>
                    <Link to="/services" className="ct-nav-link">Services</Link>
                    <Link to="/pricing" className="ct-nav-link" style={{ color: '#128C7E', fontWeight: 700 }}>Pricing</Link>
                    <Link to="/contact" className="ct-nav-link">Contact</Link>
                </div>
                <div className="ct-nav-actions">
                    {isAuthenticated ? (
                        <button onClick={() => navigate('/dashboard')} className="ct-btn-primary">Dashboard →</button>
                    ) : (
                        <>
                            <button onClick={() => setLoginModalOpen(true)} className="ct-btn-ghost">Login</button>
                            <button onClick={() => navigate('/pricing')} className="ct-btn-primary">Get Started</button>
                        </>
                    )}
                </div>
                <button className="ct-nav-hamburger" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <span /><span /><span />
                </button>
            </nav>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="ct-nav-mobile">
                    <div className="ct-mobile-menu-header">
                        <div 
    className="ct-mobile-menu-brand" 
    onClick={() => { navigate('/'); setMobileMenuOpen(false); }} 
    style={{ gap: '2px', cursor: 'pointer' }}
>
    <img src="/logo 1.png" alt="ChatTech24" style={{ height: '36px', width: 'auto', objectFit: 'contain' }} />
    <span style={{ color: '#D3D3D3', fontFamily: 'Sora, sans-serif', fontSize: '12px', fontWeight: '700' }}>ChatTech24</span>
</div>
                        <button className="ct-mobile-menu-close" onClick={() => setMobileMenuOpen(false)}>✕</button>
                    </div>
                    <div className="ct-mobile-menu-links">
                        {[['⚙️', 'How It Works', '/how-it-works'], ['✨', 'Features', '/features'], ['🚀', 'Services', '/services'], ['💎', 'Pricing', '/pricing'], ['📞', 'Contact', '/contact']].map(([icon, label, to]) => (
                            <Link key={to} to={to} className="ct-mobile-link" onClick={() => setMobileMenuOpen(false)}>
                                <span className="ct-mobile-link-icon">{icon}</span><span>{label}</span><span className="ct-mobile-link-arrow">›</span>
                            </Link>
                        ))}
                    </div>
                    <div className="ct-mobile-menu-actions">
                        <button className="ct-mobile-btn-login" onClick={() => { setLoginModalOpen(true); setMobileMenuOpen(false); }}>👤 Login</button>
                        <button className="ct-mobile-btn-cta" onClick={() => { navigate('/pricing'); setMobileMenuOpen(false); }}>🚀 Get Started</button>
                    </div>
                    <div className="ct-mobile-menu-footer">
                        <span>🔒 Secure & Reliable</span><span>⚡ 99.9% Uptime</span>
                    </div>
                </div>
            )}
            {/* ── HEADER ── */}
            <div className="pricing-header">
                <div className="pricing-header-orb pricing-header-orb-1" />
                <div className="pricing-header-orb pricing-header-orb-2" />
                <div className="pricing-header-badge">💎 Simple Pricing</div>
                <h1 className="pricing-header-title">
                    Choose Your <span>Perfect Plan</span>
                </h1>
                <p className="pricing-header-subtitle">
                    No hidden fees. Cancel anytime. Start growing your business today.
                </p>
                <div className="pricing-header-trust">
                    <span>✅ No credit card required</span>
                    <span>✅ Cancel anytime</span>
                    <span>✅ 24/7 support included</span>
                </div>

                {/* ── BILLING TOGGLE ── */}
                <div className="pricing-billing-toggle">
                    <span className={`pricing-toggle-label ${!isYearly ? 'active' : ''}`}>Monthly</span>
                    <button
                        className={`pricing-toggle-switch ${isYearly ? 'yearly' : ''}`}
                        onClick={() => setIsYearly(!isYearly)}
                        aria-label="Toggle billing cycle"
                    >
                        <span className="pricing-toggle-knob" />
                    </button>
                    <span className={`pricing-toggle-label ${isYearly ? 'active' : ''}`}>
                        Yearly
                        <span className="pricing-toggle-save-badge">Save 15%</span>
                    </span>
                </div>

                {isYearly && (
                    <p className="pricing-yearly-note">
                        🎉 Switch to a yearly plan and save <strong>15%</strong> on all plans — billed annually.
                    </p>
                )}
            </div>

            {/* ── PLANS ── */}
            <div className="pricing-plans-section">
                <div className="pricing-plans-grid pricing-plans-grid-3">

                    {PLANS.map((plan, index) => (
                        <div
                            key={plan.id}
                            className={`pricing-plan-card ${plan.popular ? 'pricing-plan-card-popular' : ''}`}
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            {plan.popular && (
                                <div className="pricing-popular-badge">⭐ Most Popular</div>
                            )}

                            {/* Header */}
                            <div className={`pricing-plan-header ${plan.headerClass}`}>
                                <h2 className="pricing-plan-name">{plan.name}</h2>
                                <p className="pricing-plan-subtitle">{plan.subtitle}</p>
                                <div className="pricing-plan-price-row">
                                    {isYearly && (
                                        <span className="pricing-plan-original-price">
                                            ₹{(plan.monthlyPrice * 12).toLocaleString()}
                                        </span>
                                    )}
                                    <span className="pricing-plan-price">
                                        ₹{getPrice(plan.monthlyPrice).toLocaleString()}
                                    </span>
                                    <span className="pricing-plan-period">{isYearly ? '/year' : '/month'}</span>
                                </div>
                                {isYearly && (
                                    <div className="pricing-annual-badge">
                                        💰 Best Value — Annual Plan
                                    </div>
                                )}
                                {plan.bestValue && !isYearly && (
                                    <div className="pricing-annual-badge">
                                        💰 Best Value — Monthly Plan
                                    </div>
                                )}
                            </div>

                            {/* Body */}
                            <div className="pricing-plan-body">
                                <div className="pricing-features-list">
                                    {plan.features.map((feature, i) => (
                                        <div key={i} className="pricing-feature-item">
                                            <span className="pricing-feature-check">✓</span>
                                            <span className="pricing-feature-text">{feature}</span>
                                        </div>
                                    ))}
                                </div>

                                <div className="pricing-messages-badge">
                                    📨 {plan.maxMessages === -1
                                        ? 'Unlimited Messages'
                                        : `${plan.maxMessages.toLocaleString()} Messages/month`}
                                </div>

                                {plan.aiEnabled && (
                                    <div className="pricing-ai-badge">
                                        🤖 AI Agent Included
                                    </div>
                                )}

                                <button
                                    onClick={() => handleSelectPlan(plan)}
                                    className={`pricing-select-btn ${plan.popular ? 'pricing-select-btn-popular' : ''} ${plan.headerClass}`}
                                >
                                    {isAuthenticated ? 'Select Plan →' : 'Get Started →'}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                {/* ── GUARANTEE STRIP ── */}
                <div className="pricing-guarantee">
                    <div className="pricing-guarantee-item">🔒 Secure Payments via Razorpay</div>
                    <div className="pricing-guarantee-item">🔄 Cancel Anytime, No Questions</div>
                    <div className="pricing-guarantee-item">💬 24/7 WhatsApp Support</div>
                    <div className="pricing-guarantee-item">⚡ 99.9% Uptime SLA</div>
                </div>

                {/* ── FAQ ── */}
                <div className="pricing-faq">
                    <h3 className="pricing-faq-title">Frequently Asked Questions</h3>
                    <div className="pricing-faq-grid">
                        {faqs.map((faq, i) => (
                            <div key={i} className="pricing-faq-card">
                                <h4 className="pricing-faq-question">❓ {faq.q}</h4>
                                <p className="pricing-faq-answer">{faq.a}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── BOTTOM CTA ── */}
                <div className="pricing-bottom-cta">
                    <h2 className="pricing-bottom-cta-title">Still Not Sure Which Plan?</h2>
                    <p className="pricing-bottom-cta-sub">Talk to our team — we'll help you pick the right plan for your business.</p>
                    <div className="pricing-bottom-cta-btns">
                        <Link to="/contact" className="pricing-cta-btn-outline">📞 Talk to Sales</Link>
                        <Link to="/how-it-works" className="pricing-cta-btn-ghost">⚙️ See How It Works</Link>
                    </div>
                </div>
            </div>

            {/* ── FOOTER ── */}
            <footer className="ct-footer">
                <div className="ct-container">
                    <div className="ct-footer-grid">
                        <div>
                            <div className="ct-nav-brand" onClick={() => navigate('/')} style={{ gap: '2px', cursor: 'pointer' }}>
                                <img src="/logo 1.png" alt="ChatTech24" style={{ height: '44px', width: 'auto', objectFit: 'contain' }} />
                                <span style={{ color: '#D3D3D3', fontFamily: 'Cooper Black', fontSize: '13px', fontWeight: '700' }}>Chat Tech 24</span>
                            </div>
                            <p className="ct-footer-tagline">AI-powered WhatsApp automation platform for modern businesses. Build, automate, and scale your customer conversations.</p>
                            <div className="ct-footer-social">
                                <a href="https://vedvika.com" target="_blank" rel="noopener noreferrer" className="ct-footer-social-link">🌐 Website</a>
                                <Link to="/contact" className="ct-footer-social-link">✉️ Contact</Link>
                            </div>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Product</div>
                            <Link to="/pricing">Pricing</Link>
                            <Link to="/features">Features</Link>
                            <Link to="/services">Services</Link>
                            <Link to="/how-it-works">How It Works</Link>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Company</div>
                            <a href="https://vedvika.com/#about" target="_blank" rel="noopener noreferrer">About Vedvika</a>
                            <Link to="/contact">Contact Us</Link>
                        </div>
                        <div className="ct-footer-col">
                            <div className="ct-footer-col-title">Support</div>
                            <Link to="/how-it-works">Documentation</Link>
                            <Link to="/contact">Talk to Sales</Link>
                            <a href="mailto:support@chattech24.com">Email Support</a>
                        </div>
                    </div>
                    <div className="ct-footer-bottom">
                        <p className="ct-footer-copy">
                            © 2026 ChatTech24 by <a href="https://vedvika.com" target="_blank" rel="noopener noreferrer">Vedvika Technologies</a>. All rights reserved.
                        </p>
                        <div className="ct-footer-legal">
                            <a href="https://vedvika.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            <a href="https://vedvika.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        </div>
                    </div>
                </div>
            </footer>

            <Login isOpen={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
                {/* ── UPSELL MODAL ── */}
{upsellModal && (
    <div className="upsell-overlay" onClick={() => setUpsellModal(null)}>
        <div className="upsell-modal" onClick={e => e.stopPropagation()}>
            <button className="upsell-close" onClick={() => setUpsellModal(null)}>✕</button>

            <div className="upsell-badge">💡 Better Deal Available</div>
            <h2 className="upsell-title">Save 15% with a Yearly Plan!</h2>
            <p className="upsell-subtitle">
                You selected <strong>{upsellModal.name}</strong> ({upsellModal.subtitle}) on monthly billing.
                Switch to yearly and pay less overall.
            </p>

            {/* Comparison */}
            <div className="upsell-compare">
                <div className="upsell-compare-box upsell-compare-monthly">
                    <div className="upsell-compare-label">Monthly Plan</div>
                    <div className="upsell-compare-price">
                        ₹{upsellModal.monthlyPrice.toLocaleString()}
                        <span>/mo</span>
                    </div>
                    <div className="upsell-compare-annual">
                        ₹{(upsellModal.monthlyPrice * 12).toLocaleString()} / year
                    </div>
                </div>

                <div className="upsell-vs">VS</div>

                <div className="upsell-compare-box upsell-compare-yearly">
                    <div className="upsell-compare-label">⭐ Yearly Plan</div>
                    <div className="upsell-compare-price">
                        ₹{Math.round(upsellModal.monthlyPrice * 12 * 0.85).toLocaleString()}
                        <span>/year</span>
                    </div>
                    <div className="upsell-compare-saving">
                        🎉 You save ₹{Math.round(upsellModal.monthlyPrice * 12 * 0.15).toLocaleString()}!
                    </div>
                </div>
            </div>

            <button className="upsell-btn-yearly" onClick={handleUpgradeYearly}>
                🚀 Yes! Get Yearly Plan & Save 15%
            </button>
            <button className="upsell-btn-monthly" onClick={handleContinueMonthly}>
                Continue with Monthly Plan →
            </button>
        </div>
    </div>
)}
        </div>
    );
}

export default PricingPlans;